import { HTMLProps, forwardRef } from 'react';

import {
  Theme,
  WithStyles,
  alpha,
  createStyles,
  withStyles,
} from '@material-ui/core/styles';

import classNames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center',
    },
    sticky: {
      position: 'sticky',
      top: theme.spacing(1),
      left: 0,
      right: 0,
      zIndex: theme.zIndex.speedDial,
      background: alpha(theme.palette.background.default, 0.8),
      '&:after, &:before': {
        height: theme.spacing(1),
        width: '100%',
        background: alpha(theme.palette.background.default, 0.8),
        position: 'absolute',
        left: 0,
        right: 0,
        content: '""',
      },
      '&:after': {
        bottom: -theme.spacing(1),
      },
      '&:before': {
        top: -theme.spacing(1),
      },
    },
  });

export interface SectionHeaderProps
  extends HTMLProps<HTMLDivElement>,
    WithStyles<typeof styles> {
  stickyHeader?: boolean;
}

const SectionHeaderMui = forwardRef<HTMLDivElement, SectionHeaderProps>(
  (props, ref) => {
    const { stickyHeader, className, classes, children, ...rest } = props;

    return (
      <div
        ref={ref}
        data-component="SectionHeader"
        data-sticky={stickyHeader || undefined}
        className={classNames(className, classes.root, {
          [classes.sticky]: stickyHeader,
        })}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

SectionHeaderMui.displayName = 'SectionMui.Header';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore Section and delete. */
export default withStyles(styles)(SectionHeaderMui);
